import { USER_CONFIG_API_URL } from '@shared/constants/API.constants';

export const getUserConfigApi = () => ({
    url: '/user-config/config',
    method: 'GET',
    baseURL: USER_CONFIG_API_URL,
});

export const editUserConfigApi = newUserConfig => ({
    baseURL: USER_CONFIG_API_URL,
    url: '/user-config/config',
    method: 'POST',
    data: newUserConfig,
});
